export const SourceHomebaseWarehouse = "homebasewarehouses";
export const SourceHomebaseWarehouseDetail = "homebasewarehouses/detail";

export const TitleHomebaseWarehouse = {
  list: "HomebaseWarehouse List",
  edit: "Edit HomebaseWarehouse",
  create: "Create HomebaseWarehouse",
  detail: "HomebaseWarehouse Detail",
};
